module.exports = __webpack_public_path__ + "img/loading.85ad9f74.gif";